import { MutationFunction, QueryFunction } from '@tanstack/react-query';
import { CreateProductDto, ProductDto, UpdateProductDto } from 'desk-common';
import api from './api';

export const getProductsList: QueryFunction<
  ProductDto[],
  readonly [string, Partial<ProductDto>]
> = async ({ queryKey }) => {
  const [, params] = queryKey;

  const hasFilters = params && Object.keys(params).length > 0;

  const response = await api.get('/products', {
    params: hasFilters ? { filters: JSON.stringify(params) } : undefined,
  });

  return response.data;
};

export const createProduct: MutationFunction<
  { productId: number },
  CreateProductDto
> = async ({ ...data }) => {
  const response = await api.post('/products', data);
  return response.data;
};

export const updateProduct: MutationFunction<
  void,
  UpdateProductDto & { id: number }
> = async ({ id, ...data }) => {
  const response = await api.put(`/products/${id}`, data);
  return response.data;
};

export const disableProduct: MutationFunction<void, { id: number }> = async ({
  id,
}) => {
  const response = await api.put(`/products/disable/${id}`);
  return response.data;
};
